import "./Spinner.scss";

export default function Spinner() {
    return (
        <div className="loader">Loading...</div>
    )
}
